import React from 'react';
import { Center, Section, Stack, Container } from '@fiverr-private/layout_components';
import { Box, theme } from '@fiverr-private/theme';
import { getContext } from '@fiverr-private/fiverr_context';
import { LIHP_STICKY_TRIGGER_ATTRIBUTE } from '@fiverr-private/header';
import { JobsTbdContainer } from '../JobsTbdContainer/JobsTbdContainer';
import ParameterizedText from '../ParameterizedText/ParameterizedText';
import { ParameterizedTextWidthType } from '../ParameterizedText/ParameterizedText.types';
import { BACKGROUND_BANNER_IMAGES } from '../../../constants';
import { HeaderSectionProps } from './HeaderSection.types';
import { titleProps } from './HeaderConstants';
import { headerContainer, childrenCustomContainer } from './HeaderSection.ve.css';

const HeaderSection = ({ title, jobsInfo, children }: HeaderSectionProps) => {
    const { isTouch } = getContext();

    const headerPaddingTop = isTouch ? '10' : '12';

    const titleWidth: ParameterizedTextWidthType = {
        default: '100%',
        lg: `calc(100%  - ${theme.spacing[4]})`,
    };

    const titleComponent = (
        <ParameterizedText
            section={title}
            color="black"
            iconColor="white"
            iconSize={32}
            width={titleWidth}
            textWrapperProps={titleProps}
        />
    );

    const hasChildren = Boolean(children);

    return (
        <Box {...{ [LIHP_STICKY_TRIGGER_ATTRIBUTE]: true }}>
            <Stack
                height={{ default: '230px', md: '174px' }}
                position="absolute"
                width="100%"
                gap="6"
                direction="column"
                zIndex="-1"
                background={{
                    default: `url(${BACKGROUND_BANNER_IMAGES.sm}) no-repeat center`,
                    md: `url(${BACKGROUND_BANNER_IMAGES.md}) no-repeat center`,
                }}
                justifyContent={'center'}
            />
            <Section
                paddingTop={headerPaddingTop}
                paddingBottom="0"
                style={isTouch ? { paddingRight: '0', paddingLeft: '0' } : {}}
            >
                <Stack
                    marginBottom="4"
                    direction={{ default: 'column', lg: 'row' }}
                    justifyContent="spaceBetween"
                    gap={{ default: '3', lg: '6' }}
                >
                    <Stack
                        width="100%"
                        direction="column"
                        gap={{ default: '8', lg: '1' }}
                        alignItems="flexStart"
                        textAlign="start"
                    >
                        {isTouch ? (
                            <Box display="flex" alignItems="baseline" paddingLeft="6" paddingRight="6">
                                {titleComponent}
                            </Box>
                        ) : (
                            titleComponent
                        )}

                        {hasChildren && (
                            <Container
                                maxWidth="1400px"
                                marginLeft="auto"
                                marginRight="auto"
                                marginTop="8"
                                width="100%"
                                className={childrenCustomContainer}
                            >
                                {children}
                            </Container>
                        )}

                        {isTouch && (
                            <Section fullWidth>
                                <Center>
                                    <JobsTbdContainer jobsInitialData={jobsInfo} />
                                </Center>
                            </Section>
                        )}
                    </Stack>
                </Stack>
            </Section>

            {!isTouch && (
                <Container
                    margin="auto"
                    paddingRight="8"
                    paddingBottom="1"
                    paddingTop="4"
                    paddingLeft="5"
                    maxWidth="1400px"
                    className={headerContainer}
                >
                    <Center>
                        <JobsTbdContainer jobsInitialData={jobsInfo} />
                    </Center>
                </Container>
            )}
        </Box>
    );
};

export default HeaderSection;
